import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString } from "vue"
import _imports_0 from '@/assets/images/icon_star_rate_full.svg'
import _imports_1 from '@/assets/images/icon_star_rate_half.svg'
import _imports_2 from '@/assets/images/icon_star_rate_empty.svg'


const _hoisted_1 = { class: "star" }
const _hoisted_2 = { class: "starRate" }
const _hoisted_3 = { class: "starRate__input" }
const _hoisted_4 = ["value"]
const _hoisted_5 = { class: "starRate__box" }
const _hoisted_6 = {
  key: 0,
  class: "starRate__star_half",
  src: _imports_1
}
const _hoisted_7 = { class: "rating" }
const _hoisted_8 = { class: "rating__span" }

import { ref } from 'vue';


export default /*@__PURE__*/_defineComponent({
  __name: 'StarInput',
  props: {
  id: {
    type: Number,
    default: 0,
  },
  modelValue: {
    type: Number,
    default: 0,
  },
},
  emits: ['update:modelValue'],
  setup(__props, { emit: __emit }) {

const props = __props;

const emits = __emit;

const rating = ref(props.modelValue);

const onChange = (e: any) => {
  const value = parseFloat((e.target as HTMLInputElement).value);
  rating.value = value;
  emits('update:modelValue', rating.value);
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("input", {
          type: "range",
          value: rating.value,
          min: "0",
          max: "5",
          step: "0.5",
          onInput: _cache[0] || (_cache[0] = ($event: any) => (onChange($event)))
        }, null, 40, _hoisted_4)
      ]),
      _createElementVNode("div", _hoisted_5, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(Math.floor(rating.value), (i) => {
          return (_openBlock(), _createElementBlock("span", { key: i }, _cache[1] || (_cache[1] = [
            _createElementVNode("img", {
              class: "starRate__star",
              src: _imports_0
            }, null, -1)
          ])))
        }), 128)),
        _createElementVNode("span", null, [
          (rating.value % 1 !== 0)
            ? (_openBlock(), _createElementBlock("img", _hoisted_6))
            : _createCommentVNode("", true)
        ]),
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(5 - Math.floor(rating.value) - (rating.value % 1 !== 0 ? 1 : 0), (i) => {
          return (_openBlock(), _createElementBlock("span", { key: i }, _cache[2] || (_cache[2] = [
            _createElementVNode("img", {
              class: "starRate__star",
              src: _imports_2
            }, null, -1)
          ])))
        }), 128))
      ])
    ]),
    _createElementVNode("div", _hoisted_7, [
      _createElementVNode("span", _hoisted_8, _toDisplayString(rating.value), 1),
      _cache[3] || (_cache[3] = _createElementVNode("span", null, "/5", -1))
    ])
  ]))
}
}

})